module.exports = __webpack_public_path__ + "static/media/ilustracao_cai_mais.cd69d801.svg";